import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { appStr } from 'src/locales/app_strings';
import { Box, ListItem, Typography, Stack } from '@mui/material';
import { IconButton, SvgIcon, Tooltip } from '@mui/material';
import PlateTextField from 'src/components/widgets/plate-textfield'
import PaginatedList from 'src/components/ui/list/paginated-list';
import HeaderCellText from 'src/components/ui/list/header-cell-text';
import ListCellText from 'src/components/ui/list/list-cell-text';
import { RouterLink } from 'src/components/router-link';
import Tool02Icon from 'src/icons/untitled-ui/free/tool-02';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

export const ListView = (props) => {
  const {
    dataStore,
    onPageChange = () => {},
    onRowsPerPageChange,
    page = 0,
    rowsPerPage = 0,
    onDetailClicked,
    onRepairClicked,
    onPagersClicked
  } = props;

  const { t } = useTranslation();
  
  const renderItem = (item, rowstyle, idx) => (
    <ListItem
      divider={true}
      key={idx}
      sx={rowstyle}
    >
      <ListCellText flex="0 0 45%" >
        <PlateTextField 
            transmission={item.transmission} 
            plate={item.plate} 
            subValue={item.brand}
            onClick={() => onDetailClicked(item)} />
      </ListCellText>

      <ListCellText flex="0 0 30%">
        <Typography variant="subtitle2" color='primary.main'>
          {item.lastKm}
        </Typography>
        <Typography variant="body3">
          {item.fuelCard}
        </Typography>
      </ListCellText>

      <ListCellText flex="0 0 25%" align='right'>
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Tooltip title="Bảo dưỡng">
            <IconButton
              component={RouterLink}
              onClick={() => onRepairClicked(item)}
            >
              <SvgIcon>
                <Tool02Icon />
              </SvgIcon>
            </IconButton>
          </Tooltip>
          <Tooltip title="Giấy tờ">
            <IconButton
              component={RouterLink}
              onClick={() => onPagersClicked(item)}
            >
              <SvgIcon>
                <DescriptionOutlinedIcon />
              </SvgIcon>
            </IconButton>
          </Tooltip>
        </Stack>
      </ListCellText>

    </ListItem>
  );

  return (
    <Box sx={{ position: 'relative' }}>
      <PaginatedList
        items={dataStore.items}
        loading={dataStore.loading}
        renderItem={renderItem}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      >
        <HeaderCellText sx={{ width: '45%' }}>{t(appStr.txt_002)}</HeaderCellText>
        <HeaderCellText sx={{ width: '30%' }}>ODO</HeaderCellText>
        <HeaderCellText sx={{ width: '25%', textAlign: 'right' }} />
      </PaginatedList>
    </Box>
  );
};

ListView.propTypes = {
  dataStore: PropTypes.object,
  onDeselectAll: PropTypes.func,
  onDeselectOne: PropTypes.func,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  onSelectAll: PropTypes.func,
  onSelectOne: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  selected: PropTypes.array,
};
